import type { CarrierInitializationMappingDrafts } from './api';

const RELOAD_MESSAGE = 'Carrier setup was updated while this page was open. Reload and try again.';

export function parseCarrierInitializationMappingDraftsResponse(
  value: unknown
): CarrierInitializationMappingDrafts | null {
  if (value === null) return null;
  if (typeof value !== 'object' || Array.isArray(value)) {
    throw new Error(RELOAD_MESSAGE);
  }
  const candidate = value as Partial<CarrierInitializationMappingDrafts>;
  if (
    !Array.isArray(candidate.serviceDefinitions)
    || !Array.isArray(candidate.groups)
    || !Array.isArray(candidate.drafts)
    || !Array.isArray(candidate.unassignedAccounts)
    || !Array.isArray(candidate.unassignedVendors)
    || !Array.isArray(candidate.ignoredRecords)
  ) {
    throw new Error(RELOAD_MESSAGE);
  }
  return candidate as CarrierInitializationMappingDrafts;
}
